import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { api } from "helpers/api_url";

export interface InventorySummaryQuery {
  page: number;
  pageSize: number;
  search?: string;
  sort?: string;
  order?: "asc" | "desc" | "";
  filters?: any;
}

export const fetchInventorySummary = createAsyncThunk(
  "inventory/inventorySummary",
  async (query: InventorySummaryQuery, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();

      params.append("page", String(query.page));
      params.append("pageSize", String(query.pageSize));

      // Search
      if (query.search) params.append("search", query.search);

      // Sorting
      if (query.sort) {
        const orderingValue =
          query.order === "desc" ? `-${query.sort}` : query.sort;
        params.append("ordering", orderingValue);
      }

      // Filters
      if (Array.isArray(query.filters)) {
        query.filters.forEach((f: any) => {
          if (f.filterField && f.filterValue !== undefined) {
            params.append(f.filterField, f.filterValue);
          }
        });
      }

      // API CALL (same as warehouse-wise stock)
      const response = await Axios.get(`${api?.dashboad?.inventory_summary_list}`, { params });
      const data = response.data;

      return {
        data: data.data || [],
        totalRecords: data.count || 0,
        low_stock_items_count: data.low_stock_items_count || 0,
        total_stock: data.total_stock || 0,
      };
    } catch (err: any) {
      return rejectWithValue(err?.response?.data || "Network Error");
    }
  }
);

